// extracted by mini-css-extract-plugin
export default {"main":"Login_main__wZIcG","container":"Login_container__0c7uz","containerSecond":"Login_containerSecond__sZ1WY","whoarewelink":"Login_whoarewelink__GE1vK"};